


import React from "react";
import SidebarUi from "./SidebarUi";
import { useDispatch } from "react-redux";
import { removeUserToken } from "../../store/slice";
import { useNavigate } from "react-router-dom";
import { useDecodeToken } from "../../Utils/function";
import { resetSelectedCEN } from "../../store/cenSlice";
import { useGetCenQuery } from "../../store/Api/cen";

function Sidebar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
 
  const decodedToken = useDecodeToken();
  const { data :cenData } = useGetCenQuery({
    search: "",
    limit: "",
    page: "",
  });

  const logOut = () => {
    dispatch(resetSelectedCEN());
    dispatch(removeUserToken({}));
    navigate("/login")
  };
  return <SidebarUi logOut={logOut} decodedToken={decodedToken} cenData={cenData?.data?.data}/>;
}

export default Sidebar;
